import { queryOptions, useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import productQueryKeys from './productQueryKeys'
import { getProducts } from '../service/productService'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { Company } from '../../../types/company/Company'
import { Product } from '../../../types/product/product'

export const useProducts = <TData = Product[]>(
  companyId?: Company['id'],
  select?: (data: Product[]) => TData,
  enabled = true
) =>
  useQuery(
    queryOptions({
      queryKey: productQueryKeys.list({ companyId }),
      queryFn: getProducts,
      enabled: !!companyId && enabled,
      gcTime: 15 * 60 * 1000,
      select: data => {
        const sorted = [...data].sort((a, b) => a.name.localeCompare(b.name))
        return select ? select(sorted) : (sorted as TData)
      }
    })
  )

export const useCtxProducts = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  return useProducts(companyId)
}
